import { useIntl } from 'react-intl';
import { PrivacyPolicySubjects } from '@alltrails/types/PrivacyPolicySubjects';
import type { Visibility } from '@alltrails/types/Visibility';
import { getPrivacyModalOptions } from '../../utils/privacyHelpers';
import DescriptiveRadioModal from '../DescriptiveRadioModal/DescriptiveRadioModal';

type PrivacyProps = {
  privacyPolicySubject: PrivacyPolicySubjects;
  onPrivacyChange: (policy: Visibility) => void;
  privacyPolicy: Visibility;
  isCollabList?: boolean;
  isAddingCollaboratorsToFollowersOnlyList?: boolean;
  isMapPrivacy?: boolean;
  closeModal: () => void;
  closeOnAccept?: boolean;
  hideCloseButton?: boolean;
  goBack?: () => void;
  hasCustomStyles?: boolean;
};

const PrivacyModal = ({
  privacyPolicySubject,
  onPrivacyChange,
  privacyPolicy,
  isCollabList,
  isAddingCollaboratorsToFollowersOnlyList,
  isMapPrivacy,
  closeModal,
  hideCloseButton,
  goBack,
  closeOnAccept,
  hasCustomStyles
}: PrivacyProps) => {
  const intl = useIntl();
  const { title, description, radioOptions } = getPrivacyModalOptions(
    privacyPolicySubject,
    intl,
    isCollabList,
    isAddingCollaboratorsToFollowersOnlyList
  );

  return (
    <DescriptiveRadioModal
      title={title}
      description={description}
      radioOptions={radioOptions}
      selected={privacyPolicy}
      acceptCallback={value => {
        onPrivacyChange(value as Visibility);
      }}
      closeModal={closeModal}
      closeOnAccept={closeOnAccept}
      goBack={goBack}
      isSave={isCollabList || isMapPrivacy}
      hasCustomStyles={hasCustomStyles}
      hideCloseButton={hideCloseButton}
    />
  );
};

export default PrivacyModal;
